document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('[data-delivery-button]');

  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      const productId = button.getAttribute('data-product-id');
      const input = document.getElementById(`tz24-delivery-plz-${productId}`);
      const loading = document.getElementById(`tz24-delivery-loading-${productId}`);
      const result = document.getElementById(`tz24-delivery-result-${productId}`);

      if (!input || !loading || !result) return;

      const plz = (input.value || '').trim();

      if (!/^\d{5}$/.test(plz)) {
        result.hidden = false;
        result.innerHTML = 'Bitte eine gültige 5-stellige PLZ eingeben.';
        loading.hidden = true;
        return;
      }

      result.hidden = true;
      loading.hidden = false;

      window.setTimeout(function () {
        const message = buildDeliveryMessage();
        loading.hidden = true;
        result.hidden = false;
        result.innerHTML = message;
      }, 1600);
    });
  });

  function buildDeliveryMessage() {
    const now = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" }));
    const day = now.getDay();
    const hour = now.getHours();

    const weekdayNames = [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag'
    ];

    const targetDate = new Date(now);

    if (day >= 1 && day <= 4) {
      if (hour < 12) {
        targetDate.setDate(now.getDate() + 1);
      } else {
        targetDate.setDate(now.getDate() + 2);
      }
    } else if (day === 5) {
      if (hour < 12) {
        targetDate.setDate(now.getDate() + 3);
      } else {
        targetDate.setDate(now.getDate() + 4);
      }
    } else if (day === 6) {
      targetDate.setDate(now.getDate() + 3);
    } else {
      targetDate.setDate(now.getDate() + 2);
    }

    const weekday = weekdayNames[targetDate.getDay()];
    const probability = hour < 12 ? '92,3 %' : '92,3 %';

    return `${probability} Wahrscheinlichkeit für Zustellung am ${weekday}.`;
  }
});